/* eslint-disable prettier/prettier */
import Component from '../abstracts/Component';

export default class ShortcutImageComponent extends Component {
    get SELECTORS() {
        return {
            shortcutImage: '[data-shortcut-image]'
        }
    }
    constructor(htmlEl) {
        super(htmlEl);
        this.$component = htmlEl;

        this.shortcutImage = document.querySelectorAll(this.SELECTORS.shortcutImage)
        
    }

    bindEvents() {

        console.warn('ShortcutImageComponent bindEvents')

        if (this.shortcutImage) {
            this.addSelection(this.shortcutImage)
        }

    }

    addSelection(list) {
        list.forEach(element => {
            let {
                isOurSelection,
                shortcutImage
            } = element.dataset

            let arr = shortcutImage.split('/')
            let arr2 = window.location.pathname.split('/')

            if (
                (isOurSelection === 'true' && shortcutImage === window.location.pathname) ||
                (
                    isOurSelection === 'false' && (
                    shortcutImage === window.location.pathname || 
                    arr[arr.length - 1] === arr2[arr2.length - 1] ||
                    arr[arr.length - 1] === arr2[arr2.length - 2] )
                )
            ) element.classList.add('active')
        });
    }

    render() {
        super.render();
        this.bindEvents();
      }
}